/**
 * 角色
 */

 import {
    get,
    post,
    put,
    del
  } from '@/util/request'

  /**
   * 根据Id查询
   * @param {*} Id
   * @returns
   */
  export const SelectRoleById = (Id) => {
    return get('/api/app/Role?CurrentId=' + Id);
  }

  /**
   * 新增数据记录
   * @param {*} data
   * @returns
   */
  export const AddRole = (data) => {
    return post('/api/app/Role', data, {});
  }

  /**
   * 更新数据记录
   * @param {*} data
   * @returns
   */
  export const ModifyRole = (data) => {
    return put('/api/app/Role', data, {});
  }

  /**
   * 分页获取
   * @param {*} data
   * @returns
   */
  export const GetDataRoleList = (data) => {
    return post('/api/app/Role/list', data, {});
  }

  /**
   * 链表分页获取
   * @param {*} data
   * @returns
   */
   export const GetDataRoleListByPageQuery = (data) => {
    return post('/api/app/Role/getDataByPageQuery', data, {});
  }

  /**
   * 删除记录
   * @param {*} id
   * @returns
   */
  export const DeleteRole = (id) => {
    return del('/api/app/Role/' + id, {}, {});
  }